import { Skeleton } from 'antd';

import { LogsGenerator } from '@app/components';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';

export const HistoryModalContent: NTasksList.HistoryModalContent = ({
  isLoading,
  historyData,
}) => {
  if (isLoading) {
    return <Skeleton active />;
  }

  return <LogsGenerator actions={historyData} isEmployee={false} />;
};
